import styleInject from './../../__node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "._8kmCr{box-shadow:inset 0 0 0 1px #b00!important}._4iqEQ{margin-right:7px}._X7G1y{background-color:rgba(11,110,208,.08);font-weight:500}";
var styles = {"isInvalid":"_8kmCr","checkbox":"_4iqEQ","selectedItem":"_X7G1y"};
var stylesheet="._8kmCr{box-shadow:inset 0 0 0 1px #b00!important}._4iqEQ{margin-right:7px}._X7G1y{background-color:rgba(11,110,208,.08);font-weight:500}";
if(typeof process !== 'object' || !process.hasOwnProperty('env') || process.env.NODE_ENV !== 'test'){styleInject(css_248z);}

export { styles as default, stylesheet };
